/* Chains the product pages together on scroll.
 *
 *   annapurna -> kilimanjaro -> huangshan -> annapurna   (overscroll at the end)
 *   any product -> home                                  (overscroll at the top)
 *
 * Overscrolling past either end builds "intent" (shown in the progress track);
 * once it passes the threshold the next page is loaded.
 */
(function () {
  'use strict';

  var CHAIN = {
    annapurna: 'kilimanjaro',
    kilimanjaro: 'huangshan',
    huangshan: 'annapurna',
  };

  var HOME = '/';

  /* Fallback when data-color-back is missing. Matches GradShader PRODUCT_GRAD. */
  var COLOR_BACK = {
    annapurna: '#E8481F',
    kilimanjaro: '#ffee8f',
    huangshan: '#73B34F',
  };

  var THRESHOLD = 420;   // px of overscroll before a step commits
  /* Stillness that lets the intent drain. Was 320ms: the pause between two
     trackpad swipes is longer than that, and on a slow machine a single long
     frame is too, so the bar reset before a second swipe could finish it. */
  var RESET_MS = 900;
  var DESKTOP_MQ = window.matchMedia('(min-width: 992px)');

  function isDesktop() {
    return DESKTOP_MQ.matches;
  }

  var canvas = document.querySelector('canvas[data-product]');
  if (!canvas) return;

  var current = canvas.dataset.product;
  if (!CHAIN[current]) return;

  var progress = document.querySelector('.pdp-scroll-progress');
  var track = document.querySelector('.pdp-scroll-progress__track');
  var intentBar = null;
  var urls = window.peakLovePdpUrls || {};
  var nextHandle = (progress && progress.getAttribute('data-next-handle')) || '';
  var nextUrl = (progress && progress.getAttribute('data-next-url')) || urls[nextHandle] || '';
  var nextBg = (progress && progress.getAttribute('data-next-bg')) || '';
  var hasNext = Boolean(nextHandle && nextUrl);

  var intent = 0;
  var dir = 0;
  var busy = false;
  var resetTimer = 0;
  var lastFeed = 0;
  var accent = '';

  /* ---------------------------------------------------------------- color -- */

  function parseRgb(input) {
    if (!input) return null;
    var s = String(input).trim();
    var rgb = s.match(/^rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)/i);
    if (rgb) return [Number(rgb[1]), Number(rgb[2]), Number(rgb[3])];
    s = s.replace(/^#/, '');
    if (s.length === 3 || s.length === 4) {
      s = s.split('').map(function (c) { return c + c; }).join('');
    }
    if (s.length === 8) {
      if (parseInt(s.slice(6, 8), 16) === 0) return null;
      s = s.slice(0, 6);
    }
    if (s.length !== 6 || /[^0-9a-f]/i.test(s)) return null;
    return [
      parseInt(s.slice(0, 2), 16),
      parseInt(s.slice(2, 4), 16),
      parseInt(s.slice(4, 6), 16),
    ];
  }

  function toHex(rgb) {
    return '#' + rgb.map(function (c) {
      var n = Math.max(0, Math.min(255, Math.round(c)));
      return (n < 16 ? '0' : '') + n.toString(16);
    }).join('');
  }

  function darkenHex(hex, amount) {
    var rgb = parseRgb(hex);
    if (!rgb) return hex;
    return toHex(rgb.map(function (c) { return c * (1 - amount); }));
  }

  function resolveAccent() {
    var back = canvas.dataset.colorBack;
    if (parseRgb(back)) return back;
    var colors = (canvas.dataset.colors || '').split(',');
    for (var i = colors.length - 1; i >= 0; i--) {
      var c = colors[i].trim();
      if (parseRgb(c)) return c;
    }
    return COLOR_BACK[current] || '';
  }

  /* ------------------------------------------------------------- prefetch -- */

  function prefetch(href, as) {
    if (!href || document.querySelector('link[rel="prefetch"][href="' + href + '"]')) return;
    var tag = document.createElement('link');
    tag.rel = 'prefetch';
    if (as) tag.as = as;
    tag.href = href;
    document.head.appendChild(tag);
  }

  function warmNext() {
    if (!hasNext) return;
    prefetch(nextUrl);
    if (nextBg) prefetch(nextBg, 'image');
  }

  var nextFetched = false;
  function fetchNext() {
    if (nextFetched || !hasNext) return;
    nextFetched = true;
    if (typeof fetch === 'function') {
      fetch(nextUrl, { credentials: 'same-origin' }).catch(function () {});
    }
    if (nextBg) {
      var img = new Image();
      img.decoding = 'async';
      img.src = nextBg;
    }
  }

  /* ---------------------------------------------------------------- setup -- */

  accent = resolveAccent();
  if (progress && accent) {
    progress.style.setProperty('--pdp-accent', accent);
    progress.style.setProperty('--pdp-accent-dark', darkenHex(accent, 0.32));
  }

  if (hasNext && track) {
    intentBar = document.createElement('span');
    intentBar.className = 'pdp-scroll-progress__intent';
    intentBar.setAttribute('aria-hidden', 'true');
    track.appendChild(intentBar);
  }

  warmNext();

  /* --------------------------------------------------------------- scroll -- */

  /* Judge the ends by where the scroll is headed as well as where the easing
     has got to. On a slow machine Lenis's eased position trails the target
     for a long time, so every wheel tick found the page "not at the bottom
     yet", reset the intent, and the next product never loaded. */
  function scrollNow() {
    if (window.lenis && typeof window.lenis.scroll === 'number') return window.lenis.scroll;
    return window.scrollY;
  }

  function scrollTarget() {
    var l = window.lenis;
    if (l && typeof l.targetScroll === 'number') return l.targetScroll;
    return scrollNow();
  }

  function maxScroll() {
    /* Lenis's own limit is the bottom its target can actually reach. */
    var l = window.lenis;
    if (l && typeof l.limit === 'number') return Math.max(0, l.limit);
    return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  }

  function atBottom() { return Math.max(scrollNow(), scrollTarget()) >= maxScroll() - 2; }
  function atTop() { return Math.min(scrollNow(), scrollTarget()) <= 2; }

  function paint() {
    if (!intentBar) return;
    intentBar.style.transform = 'scaleX(' + (intent / THRESHOLD).toFixed(4) + ')';
    intentBar.style.opacity = intent > 0 ? '1' : '0';
  }

  function drain() {
    clearTimeout(resetTimer);
    resetTimer = setTimeout(function () {
      intent = 0; dir = 0; paint();
    }, RESET_MS);
  }

  /* Positive delta = moving further down the page. */
  function feed(delta) {
    if (!isDesktop() || busy || !delta) return;

    var forward = hasNext && delta > 0 && atBottom();
    var back = delta < 0 && atTop();

    if (!forward && !back) {
      if (intent) { intent = 0; dir = 0; paint(); }
      return;
    }

    /* Judged by the clock when the next event lands, not only by the timer,
       so a janky frame can't reset the intent in the middle of a gesture. */
    var now = performance.now();
    if (now - lastFeed > RESET_MS) intent = 0;
    lastFeed = now;

    var d = forward ? 1 : -1;
    if (d !== dir) intent = 0;
    dir = d;

    intent = Math.min(THRESHOLD, intent + Math.abs(delta));
    if (d > 0) fetchNext();
    paint();
    drain();

    if (intent >= THRESHOLD) commit(d);
  }

  /* --------------------------------------------------------------- commit -- */

  function leave(href) {
    busy = true;
    clearTimeout(resetTimer);
    if (window.lenis) window.lenis.stop();
    window.location.href = href;
  }

  function commit(d) {
    if (busy) return;
    if (d > 0) {
      if (!hasNext) return;
      leave(nextUrl);
    } else {
      leave(HOME);
    }
  }

  /* ------------------------------------------------------------- listeners -- */

  window.addEventListener('wheel', function (e) {
    /* Some mice report lines or pages rather than pixels. */
    var k = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? window.innerHeight : 1;
    feed(e.deltaY * k);
  }, { passive: true });

  var touchY = null;

  window.addEventListener('touchstart', function (e) {
    touchY = e.touches[0].clientY;
    intent = 0; dir = 0; paint();
  }, { passive: true });

  window.addEventListener('touchmove', function (e) {
    if (touchY === null) return;
    var y = e.touches[0].clientY;
    feed(touchY - y);          // finger up = further down the page
    touchY = y;
  }, { passive: true });

  window.addEventListener('touchend', function () {
    touchY = null;
    intent = 0; dir = 0; paint();
  }, { passive: true });

  // Keyboard parity for the forward step.
  window.addEventListener('keydown', function (e) {
    if (!isDesktop() || busy) return;
    if (e.key === 'PageDown' && hasNext && atBottom()) commit(1);
    if (e.key === 'PageUp' && atTop()) commit(-1);
  });

  window.PeakLovePdpChain = {
    current: current,
    next: hasNext ? nextHandle : null,
    accent: accent,
    intent: function () { return intent / THRESHOLD; },
    commit: commit,
  };
})();
